import {ThreadGroupVariant} from './util/classify-thread'
import {useUnresolvedThreadGroups} from './data/use-unresolved-threads'
import {ForYouThreadItem} from './shared/ForYouThreadItem'

export function UnresolvedComments() {
  const {commented, repliedMentioned, replied, mentioned} = useUnresolvedThreadGroups()

  return (
    <>
      {mentioned.map(thread => (
        <ForYouThreadItem thread={thread} variant={ThreadGroupVariant.Mentioned} key={thread.id} />
      ))}
      {replied.map(thread => (
        <ForYouThreadItem thread={thread} variant={ThreadGroupVariant.Replied} key={thread.id} />
      ))}
      {repliedMentioned.map(thread => (
        <ForYouThreadItem thread={thread} variant={ThreadGroupVariant.RepliedMentioned} key={thread.id} />
      ))}
      {commented.map(thread => (
        <ForYouThreadItem thread={thread} variant={ThreadGroupVariant.Commented} key={thread.id} />
      ))}
    </>
  )
}
